/**
 * Enrolling, listing and revoking tablets, and setting PINs (#80) — the
 * calls made from a proper sign-in. The lock screen's own calls are in
 * tablet.ts, because they speak for the tablet rather than for a person.
 */

import { request } from "./api.js";

export interface ShownTablet {
  readonly deviceId: string;
  readonly venueId: string;
  readonly name: string;
  readonly enrolledAt: string;
  readonly enrolledBy: string;
  readonly lastSeenAt: string | null;
  readonly revokedAt: string | null;
}

export const tabletsApi = {
  list: (token: string) => request<{ devices: readonly ShownTablet[] }>(token, "GET", "/v1/devices"),
  enrol: (token: string, venueId: string, name: string) =>
    request<{ device: ShownTablet; token: string }>(token, "POST", "/v1/devices", { venueId, name }),
  revoke: (token: string, deviceId: string) =>
    request<{ revoked: string }>(token, "DELETE", `/v1/devices/${encodeURIComponent(deviceId)}`),
  setPin: (token: string, pin: string) => request<{ pinSet: boolean }>(token, "PUT", "/v1/me/pin", { pin }),
  removePin: (token: string) => request<{ pinSet: boolean }>(token, "DELETE", "/v1/me/pin"),
  clearPin: (token: string, userId: string) =>
    request<{ cleared: string }>(token, "DELETE", `/v1/org/members/${encodeURIComponent(userId)}/pin`),
};
